import 'flag-icon-css/css/flag-icon.css'


//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-flag-icon/vendors/index.js
// module id = 711
// module chunks = 29